import { decorate, observable } from 'mobx';
import ListData from '../toolkit/mobx-connectors/observables/list-data';

class PersonaStore {
  list = new ListData();
}

decorate(PersonaStore, {
  list: observable
});

const personasStore = new PersonaStore();
const personasFormStore = new PersonaStore();

export { personasFormStore };
export default personasStore;
